// @ts-nocheck

import React, { MouseEventHandler, useEffect, useRef } from 'react';

import styled from 'styled-components';

import { FormProps } from '@progress/kendo-react-form';
import { Input, InputProps } from '@progress/kendo-react-inputs';
import { Error, Label, LabelProps } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { flowItemTypeEnum } from '../utils';

export type FormInputProps = Pick<LabelProps, 'id' | 'optional'> & InputProps;
export type CreateItemFormProps = Pick<FormProps, 'initialValues'> & {
    onHandleBack?: MouseEventHandler<HTMLButtonElement>;
    RenderInfo?: React.FC;
    component?: { displayName: string; description: string };
    onSubmit: (data: { name: string; description: string }) => void;
    selectedItemType?: (typeof flowItemTypeEnum)[keyof typeof flowItemTypeEnum];
    getNameForNewItem?: (name: string) => string;
};

export const FieldWrapper = ({ children }: any) => <div style={{ marginTop: '4px' }}>{children}</div>;
export const ButtonWrapper = ({ children }: any) => <div style={{ marginTop: '8px' }}>{children}</div>;
export const InputStyled = styled(Input)`
    body:not(.kendo-ng) & {
        width: 100%;
        border-color: #dadada;
        font-size: 12px;
        color: #595959;

        &.k-textbox {
            padding: 4px 8px;
            height: calc(1.4285714286em + 10px);
            border: solid 1px #c5c5c5;
            border-radius: 2px;
        }

        &:focus,
        &:focus-within,
        &.k-focus,
        &.k-focus {
            border-color: rgba(0, 0, 0, 0.1);
            box-shadow:
                0 2px 4px 0 rgba(0, 0, 0, 0.03),
                0 4px 5px 0 rgba(0, 0, 0, 0.04);
        }

        &:hover {
            border-color: rgba(0, 0, 0, 0.15);
        }
    }
`;
export const InputSearchStyled = styled(Input)`
    body:not(.kendo-ng) & {
        width: 100%;
        border-color: #dadada;
        font-size: 12px;
        color: #595959;

        &.k-textbox {
            padding: 4px 0;
            height: calc(1.4285714286em + 10px);
            border-bottom: 1px solid #c5c5c5;
            border-radius: 0;
            text-indent: 0;
        }

        &:focus,
        &:focus-within,
        &.k-focus,
        &.k-focus {
            border-color: rgba(0, 0, 0, 0.15);
            box-shadow: none;
        }

        &:hover {
            border-color: rgba(0, 0, 0, 0.15);
        }
    }
`;
export const LabelStyled = styled(Label)`
    font-size: 12px;
    color: #7a7a7a;
`;
export const KButtonStyled = styled(Button)`
    body:not(.kendo-ng) & {
        font-size: 12px;
        background-color: #fff !important;
        background-image: none;
        border-radius: 2px;
        padding: 4px 8px;
        text-transform: none;
        box-shadow: none !important;
        //font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;

        &.k-button:hover {
            background-color: #fff;
            background-image: none;
        }

        &:disabled,
        &.k-disabled {
            outline: none;
            opacity: 0.6;
            filter: grayscale(0.1);
            pointer-events: none;
            box-shadow: none;
            background-color: #e9e9e9 !important;
        }

        &:before {
            display: none;
        }
    }
`;
export const PrimaryButtonStyled = styled(KButtonStyled)`
    body:not(.kendo-ng) & {
        color: #529ec3 !important;
        border: solid 1px #529ec3 !important;
        float: right;

        &.k-button:hover {
            border-color: #75cef9 !important;
            color: #75cef9 !important;
        }
    }
`;
export const SecondaryButtonStyled = styled(KButtonStyled)`
    body:not(.kendo-ng) & {
        color: #7a7a7a !important;
        border: solid 1px #c5c5c5 !important;
        float: left;

        &.k-button:hover {
            border-color: rgba(0, 0, 0, 0.15) !important;
            color: #9c9c9c !important;
        }
    }
`;

export const FormInput = (fieldRenderProps: FormInputProps) => {
    // @ts-ignore
    const { label, id, valid, disabled, type, optional, value, visited, validationMessage, ...rest } = fieldRenderProps;
    const $input = useRef<any>(null);

    useEffect(() => {
        if (rest.autoFocus) {
            setTimeout(() => {
                $input.current?.focus();
                $input.current?._input?.select();
            }, 10);
        }
        // eslint-disable-next-line
    }, [1]);

    return (
        <FieldWrapper>
            <LabelStyled editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
                {label}
            </LabelStyled>
            {/* @ts-ignore*/}
            <InputStyled valid={valid} type={type} id={id} disabled={disabled} value={value} ref={$input}/* @ts-ignore */ {...rest} />

            {visited && validationMessage && <Error>{validationMessage}</Error>}
        </FieldWrapper>
    );
};
export const FormSearchInput = (fieldRenderProps: FormInputProps) => {
    const { label, id, valid, disabled, type, optional, value, ...rest } = fieldRenderProps;
    const $input = useRef(null);

    return (
        <FieldWrapper>
            <LabelStyled editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
                {label}
            </LabelStyled>
            <InputSearchStyled
                type={type}
                id={id}
                value={value}
                placeholder="Search component"
                ref={$input}
                {...rest}
            />
        </FieldWrapper>
    );
};

type LinkProps = {
    children: React.ReactNode;
    handleClick: () => any;
};
export const Link: React.FC<LinkProps> = ({ children, handleClick }) => {
    return (
        <a
            onClick={handleClick}
            style={{
                fontSize: '12px',
                cursor: 'pointer',
            }}
        >
            {children}
        </a>
    );
};
